import type { Ball, MatchState, Player } from "@golazo/shared";

/**
 * Huella del estado simulado, para que el server compare a dos clientes en el
 * mismo tick. La simulacion es determinista por diseño, pero nada lo verificaba:
 * dos navegadores podian divergir y cada jugador ver un partido distinto sin
 * enterarse. Esto no arregla un desync, lo hace visible.
 *
 * Se cuantiza a milesimas antes de mezclar: no queremos que un ULP de diferencia
 * en el render (o en un valor que no afecta a la jugada) dispare una alarma, pero
 * cualquier divergencia real crece muy por encima de ese umbral en pocos ticks.
 */
const QUANT = 1000;

function mix(h: number, value: number): number {
  const q = Math.round(value * QUANT) | 0;
  let x = (h ^ q) >>> 0;
  x = Math.imul(x, 0x01000193) >>> 0;
  return x;
}

export function stateHash(players: readonly Player[], ball: Ball, state: MatchState): string {
  let h = 0x811c9dc5;
  // Orden fijo por id: el hash no puede depender del orden del array.
  for (const p of [...players].sort((a, b) => a.id.localeCompare(b.id))) {
    h = mix(h, p.pos.x);
    h = mix(h, p.pos.y);
    h = mix(h, p.vel.x);
    h = mix(h, p.vel.y);
  }
  h = mix(h, ball.pos.x);
  h = mix(h, ball.pos.y);
  h = mix(h, ball.vel.x);
  h = mix(h, ball.vel.y);
  h = mix(h, state.score.home);
  h = mix(h, state.score.away);
  return (h >>> 0).toString(16);
}
